import React from "react";
import ReactDOM from "react-dom/client";
import 'process/browser';
import "./App.css";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import { StoreProvider } from "easy-peasy";
import MainStore from "./Store";
import { ToastContainer } from "react-toastify";
import { ThirdwebProvider } from "thirdweb/react";
import { AppProvider, AppContext } from "./AppContext";
import { defaultMaalReserveUSDT } from './Web3/Constents';


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StoreProvider store={MainStore}>
    <React.StrictMode>
      <ThirdwebProvider>
        <AppProvider>
            <App />
        </AppProvider>
        <ToastContainer />
      </ThirdwebProvider>
    </React.StrictMode>
  </StoreProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
